import React from 'react';

// Small red message shown under a field. Renders nothing when there is no error.
// Pass id={`${fieldId}-error`} so the field can point to it with aria-describedby.
const FieldError = ({ message, id }) =>
  message ? <p id={id} className="text-red-400 text-xs mt-1" role="alert">{message}</p> : null;

export default FieldError;
